import React from 'react';
import PropTypes from 'prop-types';
import Select from '@mui/material/Select';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';

import { HORSE_ACCESS_TYPE } from '../../../utils/enumHelper';

class HorseAccessTypeSelectComponent extends React.Component {
  render() {
    const {
      onChange,
      value,
      includeAllOption,
      ...rest
    } = this.props;
    // Client, Veterinarian, Farrier

    return (
      <FormControl fullWidth margin="none">
        <InputLabel id="note-type-select-label">Type of Horse User</InputLabel>
        <Select
          labelId="horse-access-type-select-label"
          id="horse-access-type-select"
          value={value}
          label="Type of Horse User"
          onChange={onChange}
          {...rest}
        >
          {includeAllOption && <MenuItem value="">All</MenuItem>}
          { HORSE_ACCESS_TYPE.map((nt) => (
            <MenuItem key={`horse-access-menu-item-${nt.enum}`} value={nt.enum}>{nt.label}</MenuItem>
          ))}
        </Select>
      </FormControl>
    );
  }
}

HorseAccessTypeSelectComponent.propTypes = {
  onChange: PropTypes.func,
  value: PropTypes.string,
  includeAllOption: PropTypes.bool,
};

HorseAccessTypeSelectComponent.defaultProps = {
  onChange: () => {},
  value: null,
  includeAllOption: false,
};

export default (HorseAccessTypeSelectComponent);
